<template>
  <div class="education-system-box">
    <div class="show-flex-box-c">
      <dl class="show-flex-box-c">
        <dt class="show-flex-box-c">
          <span>培训体系</span>
          <strong></strong>
        </dt>
        <dd class="system-class show-flex-box-c">
          <ul class="show-flex-box-r">
            <li v-for="(item,index) in systemClassification" :key="index" :class="{'li-active':item.mark == defaultCateMark}" @click="tabToChangeClass(item.mark,item.id)">
              <span class="show-flex-box-r show-flex-center">
                <strong>{{item.name}}</strong>
              </span>
            </li>
          </ul>
        </dd>
        <dd class="system-class-pic-box">
          <div class="show-flex-box-r">
            <span class="show-flex-box-r" v-for="(Ditem,Dindex) in systemClassification[defaultClass].pic" :key="Dindex">
              <img :src="Ditem.img" alt="德阳经开科创" draggable="false">
            </span>
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'education_system_cpn',
  data () {
    return {
      systemClassification: [
        {'id': 0,'name': '营销支持', 'mark': 'marketSupport','pic': [
          {'img': require('../../assets/home/education_system/education_system_1_1.jpg')},
          {'img': require('../../assets/home/education_system/education_system_1_2.jpg')}
        ]},
        {'id': 1,'name': '教师培训', 'mark': 'teacherTraining','pic': [
          {'img': require('../../assets/home/education_system/education_system_2_1.jpg')},
          {'img': require('../../assets/home/education_system/education_system_2_2.jpg')}
        ]},
        {'id': 2,'name': '校长培训', 'mark': 'principalTraining','pic': [
          {'img': require('../../assets/home/education_system/education_system_3_1.jpg')},
          {'img': require('../../assets/home/education_system/education_system_3_2.jpg')}
        ]},
        {'id': 3,'name': '客服体系', 'mark': 'locationService','pic': [
          {'img': require('../../assets/home/education_system/education_system_4_1.jpg')},
          {'img': require('../../assets/home/education_system/education_system_4_2.jpg')}
        ]},
        {'id': 4,'name': '赛事支持', 'mark': 'serviceSystem','pic': [
          {'img': require('../../assets/home/education_system/education_system_5_1.jpg')},
          {'img': require('../../assets/home/education_system/education_system_5_2.jpg')}
        ]},
      ],
      defaultCateMark: 'marketSupport',     //默认选中
      defaultClass: 0
    }
  },
  methods: {
    tabToChangeClass: function(curMark,curId) {
      this.defaultCateMark = curMark;
      this.defaultClass = curId;
    }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .education-system-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .education-system-box{
    width: 100%;
    background: #fafafa;
    &>div{
      margin: 0 auto;
      width: 1200px;
      align-items: center;
      &>dl{
        width: 100%;
        align-items: center;
        &>dt{
          align-items: center;
          &>span{
            word-wrap: none;
            .education-system-font-style( 40px; bold; auto; #191D21 );
            padding-top: 85px;
          }
          &>strong{
            display: block;
            width: 130px;
            height: 5px;
            background: #FF7800;
            margin-top: 19px;
            margin-bottom: 60px;
          }
        }
        &>.system-class{
          width: 100%;
          margin-bottom: 60px;
          &>ul{
            padding-left: 100px;
            padding-right: 100px;
            justify-content: space-between;
            align-items: center;
            &>li{
              cursor: pointer;
              &>span{
                width: 160px;
                height: 60px;
                box-shadow:0px 2px 6px 0px rgba(127,127,127,0.25);
                border-radius:10px;
                transition: 0.3s all;
                &>strong{
                  .education-system-font-style( 18px; 500; auto; #2D2D2D );
                  transition: 0.3s all;
                }
              }
            }
            &>li:hover{
              &>span{
                background: #FF7800;
                border-radius:10px;
                &>strong{
                  .education-system-font-style( 18px; 500; auto; #fff );
                }
              }
            }
            &>.li-active{
              &>span{
                background: #FF7800;
                border-radius:10px;
                &>strong{
                  .education-system-font-style( 18px; 500; auto; #fff );
                }
              }
            }
          }
        }
        &>.system-class-pic-box{
          width: 100%;
          padding-bottom: 102px;
          &>div{
            width: 100%;
            justify-content: space-between;
            align-items: center;
            &>span{
              overflow: hidden;
              display: block;
              width: 590px;
              height: 280px;
              border-radius: 10px;
              &>img{
                display: block;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/education_system_cpn.vue